import * as arrayUtils from '../arrays/array-utils'
import { MojoWellKnownNames } from '../constants/mojo-well-known-names';

/**
 * Prepares utility callbacks based on the currentDashboard and effectiveProduct
 */
export class FilterAvailabilityCallbacks {

  allowedForCurrentProduct(product: string) {
    return this.effectiveProduct === product;
  }

  allowedForMojoDashboardsProduct() {
    return this.effectiveProduct === MojoWellKnownNames.Products.MojoDashboard;
  }

  includedOnDashboard(allowedDashboards: string[]) {
    return arrayUtils.includesOrEmpty(this.currentDashboard, allowedDashboards);
  }

  excludedOnDashboard(excludedDashboards: string[]) {
    return arrayUtils.excludesOrEmpty(this.currentDashboard, excludedDashboards);
  }

  includedOnDashboardsForProduct(allowedDashboards: string[], product: string) {
    return this.allowedForCurrentProduct(product) && this.includedOnDashboard(allowedDashboards);
  }

  includedOnDashboardsForMojoDashboardProduct(allowedDashboards: string[]) {
    return this.allowedForMojoDashboardsProduct() && this.includedOnDashboard(allowedDashboards);
  }

  always() {
    return true;
  }

  constructor(
    public currentDashboard: string,
    public effectiveProduct: string
    ) {
  }

}
